export const newChangePlan = {
  mountedStyle: { animation: 'inAnimation 250ms ease-in' },

  unmountedStyle: {
    animation: 'outAnimation 270ms ease-out',
    animationFillMode: 'forwards'
  },

  pricingHeaderStyle: {
    fontFamily: 'Inter',
    fontSize: { xs: '30px', md: '40px' },
    fontWeight: '600',
    lineHeight: { xs: '40px', md: '50px' },
    letterSpacing: '-0.02em',
    textAlign: 'center',
    color: 'var(--color-primary)',
    marginBottom: { xs: '10px', md: '15px' }
  },

  pricingDescriptionStyle: (isLocalSeo?: any) => ({
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: '500',
    lineHeight: 'var(--line-height-28)',
    letterSpacing: '0em',
    textAlign: 'center',
    color: 'var(--color-primary)',
    width: isLocalSeo ? '34rem' : '22rem'
  }),

  tabListStyle: {
    '.Mui-selected': {
      background: 'transparent',
      border: 0,
      color: 'var(--color-black)',
      cursor: 'pointer',
      borderRadius: '300px',
      padding: '4px 8px',
      width: '85px',
      height: '31px',
      minWidth: 'unset'
    },
    '.MuiTab-root': {
      background: 'transparent',
      border: 0,
      color: 'var(--color-text-placeholder)',
      cursor: 'pointer',
      borderRadius: '300px',
      padding: '4px 8px'
    }
  },

  tableContainerStyle: {
    overflowY: 'auto',
    //background: 'white !important',
    background: 'var(--color-bg-purple-light) !important',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      display: 'block',
      width: '0px'
    },
    '&::-webkit-scrollbar-track': {
      background: 'var(--color-bg-grey3)',
      borderRadius: '0px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'var(--color-text-grey3)',
      borderRadius: '0px',
      '&:hover': {
        background: 'var(--color-text-medium-grey)'
      }
    },
    msOverflowStyle: 'auto'
  },

  stickyCardComponentStyle: {
    border: 'none',
    minWidth: '233px',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    background: 'linear-gradient(white 20%, transparent, transparent)'
  },

  planDescriptionStyle: {
    position: 'sticky',
    top: '0',
    zIndex: 2,
    backgroundColor: 'var(--color-bg-purple-light)',
    whiteSpace: 'nowrap',
    border: 'none',
    minWidth: '233px'
    // verticalAlign: 'bottom',
    // padding: '3rem !important',
  },

  greenCheckAvatarStyle: {
    height: '30px',
    width: '30px',
    borderRadius: '1px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '5px'
  },

  bestValueAvatarStyle: {
    height: '.8rem',
    width: '.8rem',
    marginLeft: 'auto',
    marginRight: 'auto',
    margin: '0px !important',
    padding: '0px !important'
  },

  recommendedChipStyle: {
    position: 'absolute !important',
    top: '.3rem !important',
    background: 'var(--color-success-bg)',
    color: 'var(--color-primary)',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 20
  },

  //recommendedMobileChipStyle: {
  //  position: 'absolute !important',
  //  top: '70% !important',
  //  background: 'var(--color-success-bg)',
  //  color: 'var(--color-primary)',
  //  left: '50%',
  //  transform: 'translateX(-50%)',
  //  zIndex: 20
  //},

  recommendedMobileChipStyle: {
    position: 'absolute',
    top: '-1rem', // Move the chip upwards to make it half outside the card
    left: '50%',
    transform: 'translateX(-50%)', // Center horizontally
    background: 'var(--color-success-bg)',
    color: 'var(--color-primary)',
    padding: '0.25rem 0.5rem', // Add padding to make it visually balanced
    borderRadius: '12px', // Slightly round the chip for aesthetics
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Optional: Add shadow for better visibility
    zIndex: 20
  },

  cardContentStyles: {
    padding: '.4rem !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  cardStyles: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '233px'
  },

  contentStyles: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },

  titleStyles: {
    fontSize: 24,
    minHeight: 24,
    marginBottom: 1
  },

  priceStyles: {
    fontSize: 'var(--font-size-32)',
    fontWeight: '700',
    color: 'var(--color-primary)'
  },

  discountedPriceStyles: {
    color: 'var(--color-border-muted)',
    fontSize: 'var(--font-size-20)',
    fontWeight: '500',

    textDecoration: 'line-through'
  },
  subTextStyles: {
    fontWeight: '400',
    fontSize: 'var(--font-size-14)',
    lineHeight: 1.2,
    color: 'var(--color-text-mid)',
    minHeight: '60px'
  },
  iconDiv: {
    position: 'fixed',
    top: '10px',
    left: '10px',
    zIndex: 9999,
    padding: '4px',
    backgroundColor: 'var(--color-bg-purple-light)'
  },
  icon: {
    height: '30px', // exact image height
    width: 'auto', // maintain aspect ratio
    display: 'block'
  },
  localSeoIcon: {
    height: '35px', // exact image height
    width: 'auto', // maintain aspect ratio
    display: 'block'
  }
};

export const infoModalSxs = {
  priceBoxSx: {
    padding: '12px 18px 12px 18px',
    gap: '16px',
    borderRadius: '6px',
    backgroundColor: 'var(--color-bg-muted-alt)'
  },
  noteTextSx: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  noteTextNewSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-18)',
    color: '#5D5F6C'
  },
  infoIconSx: {
    color: 'var(--color-secondary)',
    fontSize: 'var(--font-size-16)'
    //marginLeft: '10px'
  },
  infoIconBoxSx: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px'
  },
  checkBoxNoteText: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    letterSpacing: '0.3px'
  },
  learnMoreBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  billingBox: {
    marginTop: '16px'
  },
  listBoxSx: {
    marginTop: '16px'
  },
  btnSx: {
    marginTop: '8px'
  },
  changePayment: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)',
    cursor: 'pointer',
    marginTop: '8px'
  },
  checkBoxMainBox: {
    padding: '12px 18px 12px 18px',
    gap: '16px',
    borderRadius: '6px'
  },
  downgradeFreeSiteTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  freeDowngradeTitle: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    color: 'var(--color-primary)'
  },
  freeDowngradeMainBox: {
    padding: '24px'
  },
  freeDowngradeDesc: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginTop: '4px'
  },
  stayOnBtnText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center'
  },
  freeDowngradeBtnBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  freeDowngradeStayBtn: {
    paddingTop: '12px',
    paddingRight: '8px',
    paddingBottom: '12px',
    paddingLeft: '8px',
    gap: '8px',
    borderRadius: '6px'
  },
  imgBoxSx: {
    height: '16px',
    marginTop: '1px'
  },
  noSelectionError: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-error-dark)'
  },
  noSelectionErrorBox: {
    display: 'flex',
    gap: '4px',
    alignItems: 'flex-start',
    marginBottom: '8px'
  },
  placeHolderText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)'
  },
  noSelectionFieldErrorBox: {
    display: 'flex',
    gap: '4px',
    alignItems: 'flex-start',
    marginTop: '4px',
    marginRight: 'auto'
  },
  freeDowngradeHeadBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  iconBtn: {
    height: '40px',
    padding: '8px',
    marginRight: '-13px'
  }
};

export const downGradeOfferModalSxs = {
  mainBoxSx: {
    padding: '24px'
  },
  beforeDownGradeSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    textAlign: 'center',
    color: 'var(--color-primary)',
    width: '100%',
    marginLeft: '32px'
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '8px'
  },
  offerBoxSx: {
    borderRadius: '6px',
    padding: '24px',
    gap: '20px',
    backgroundColor: 'var(--color-bg-purple-tint)',
    minHeight: '100px',
    width: '100%',
    marginTop: '24px',
    position: 'relative'
  },
  btnBoxSx: {
    display: 'flex',
    gap: '8px',
    marginTop: '24px'
  },
  btnSx: {
    borderRadius: '6px',
    gap: '8px',
    paddingTop: '12px',
    paddingRight: '18px',
    paddingBottom: '12px',
    paddingLeft: '18px'
  },
  btnTextSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-primary)'
  },
  offerCardHeadTextSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-primary)',
    textAlign: 'center'
  },
  offerCardDescTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-24)',
    lineHeight: 'var(--line-height-32)',
    color: 'var(--color-primary)',
    textAlign: 'center',
    marginTop: '12px'
  },
  offerCardBtnSx: {
    borderRadius: '6px',
    gap: '8px',
    paddingTop: '12px',
    paddingRight: '8px',
    paddingBottom: '12px',
    paddingLeft: '8px',
    marginTop: '20px'
  },
  recommendedMobileChipStyle: {
    position: 'absolute',
    top: '-1rem', // Move the chip upwards to make it half outside the card
    left: '80%',
    transform: 'translateX(-50%)', // Center horizontally
    background: 'var(--color-success-bg)',
    color: 'var(--color-primary)',
    padding: '0.25rem 0.5rem', // Add padding to make it visually balanced
    borderRadius: '12px', // Slightly round the chip for aesthetics
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Optional: Add shadow for better visibility
    zIndex: 20
  },
  billedMonthlyTextSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-primary)'
  },
  beforeDownGradeBoxSx: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
};
